import React from 'react';

class VenueTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeLine: null
    }
  }

  _highlightLine(index) {
    this.setState({activeLine: index});
  }

  _renderItem(item, index){

    let activeClass = (this.state.activeLine == index) ? 'active' : null;

    let {name, address, infrastructures} = item.node;

    return (
      <tr className={activeClass}
        key={index}
        onClick={() => {this._highlightLine(index); this.props.onItemClick(item.node, index)}}>
            <td>
                {name}
            </td>
            <td>
                {address 
                ?   address.city + ' , ' + address.country
                :   'unknown'
                }
            </td>
            <td>
                {infrastructures && infrastructures.length}
            </td>
      </tr>
    );
  }

  render() {
    const dataSource = this.props.dataSource;

    return (
      <table className="table table-hover table-condensed">
        <thead>
          <tr>
            <th>Name</th>
            <th>Location</th>
            <th>Number of infrastructures</th>
          </tr>
        </thead>

        <tbody>
          {dataSource.map((item, index) => this._renderItem(item, index))}
        </tbody>
      </table>
    )
  }


}

VenueTable.propTypes = ({
  dataSource : React.PropTypes.array.isRequired,
  onItemClick: React.PropTypes.func.isRequired,
});




export default VenueTable;



// WEBPACK FOOTER //
// ./src/components/VenueTable.js